import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { TheLineup } from './types';

export function useTheLineupData(): Page<TheLineup> {
  return useCurrentPage<Page<TheLineup>>();
}
